import { DOCUMENT, inject, Service } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { Scope } from '@sentry/angular';

const VERSION_REGEX = /<base[^>]*\bhref=['"][^'"]*\/(\d+\.\d+\.\d+)\/?['"]/i;

@Service()
export class SentryService {
  readonly #document = inject(DOCUMENT);

  #enabled = false;
  #version = 'local';

  captureException(errorId: string, error: unknown): void {
    if (!this.#enabled) {
      return;
    }

    Sentry.withScope((scope: Scope) => {
      scope.setTag('application', 'auth-frontend');
      scope.setTag('errorId', errorId);
      scope.setTag('version', this.#version);

      Sentry.captureException(error);
    });
  }

  initialize(environment: string, enabled?: boolean, dsn?: string): void {
    if (!(enabled && dsn)) {
      return;
    }

    this.#version = this.#document.documentElement.outerHTML.match(VERSION_REGEX)?.[1] ?? 'local';

    Sentry.init({
      dsn,
      enableLogs: true,
      environment,
      integrations: [
        Sentry.browserTracingIntegration({ ignorePerformanceApiSpans: [/^boomr:/] }),
        Sentry.replayIntegration({ blockAllMedia: true, maskAllText: true }),
      ],
      propagateTraceparent: true,
      release: `release-${this.#version}`,
      replaysOnErrorSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      tracePropagationTargets: ['localhost', /^\/api/],
      tracesSampleRate: 1.0,
    });

    this.#enabled = true;
  }
}
